export default __webpack_public_path__ + "static/media/noFear.58bec93f.png";